<template>
  <a-modal
    title="新建"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="model !== null">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-if="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                :disabled="model !== null"
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择项目' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
              <span>
                {{ model.project }}
              </span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-else>
            <a-form-item label="付款申请" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                allow-clear
                :not-found-content="paymentFetching ? undefined : null"
                show-search
                v-decorator="[
                  'application_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入付款申请业务号"
                @search="this.paymentSearch"
                @change="handlePaymentApplicationChange"
              >
                <a-spin v-if="paymentFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in paymentList" :key="d.id">
                  {{ d.business_no }}（{{ d.payment_company }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="合同类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-cascader
                :disabled="model !== null"
                v-decorator="[
                  'contract_type',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                :options="this.tradePaymentRelatedContract"
                placeholder="请选择"
                @change="contractTypeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model !== null">
            <a-form-item :label="contractLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span>
                {{ model.contract_number }}
              </span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="contractType === 100">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :disabled="model !== null"
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.number }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="contractType === 200">
            <a-form-item label="普通合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :disabled="model !== null"
                v-decorator="[
                  'contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in contractList">{{ val.contract_number }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="(contractType === 100 || contractType === 200)">
            <a-form-item label="客户" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :disabled="model !== null"
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'client_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入客户"
                :default-active-first-option="false"
                @search="this.clientSearch"
                @change="handleClientChange"
              >
                <a-select-option v-for="d in clientList" :key="d.client_id" :tt="d.client">
                  {{ d.client }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="productName && (contractType === 100 || contractType === 200)">
            <a-form-item label="货物" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              {{ model.product_name }}
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              财务信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="电汇付款" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-radio-group v-decorator="['is_total_pay', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <a-radio :value="0">部分电汇</a-radio>
                <a-radio :value="1">全部电汇</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="amountChange" placeholder="付款金额"/>
              <a-select
                v-decorator="[
                  'currency',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                style="width: 50%"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购汇汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['purchase_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" @change="purchaseRateChange" placeholder="购汇汇率"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="本币金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['amount_cny', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入金额"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="款项性质" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                allow-clear
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="付款时间" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                style="width:100%"
                v-decorator="['pay_time', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD HH:mm:ss"
                show-time
                placeholder="请选择时间"
                @ok="payTimeOK"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea :rows="1" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="备注"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="false">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { project_client_list } from '@/api/trade_project_client'
import { sell_contract_list } from '@/api/trade_sell_contract'
import {
  booking_contract_list,
  charter_party_contract_list,
  freight_forwarding_contract_list,
  inspection_contract_list,
  insurance_contract_list,
  loading_supervision_contract_list,
  storage_contract_list, supervision_contract_list
} from '@/api/trade_contract'
import { guarantee_contract_list } from '@/api/trade_guarantee_contract'
import { contract_list } from '@/api/contract'
import { payment_application_list } from '@/api/trade_payment'

// 表单字段
const fields = ['id', 'contract_type', 'contact', 'phone', 'mail']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.clientSearch = debounce(this.handleClientSearch, 800)
    this.paymentSearch = debounce(this.handlePaymentSearch, 800)
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      projectFetching: false,
      paymentFetching: false,
      projectList: [],
      clientList: [],
      sellContractList: [],
      contractList: [],
      paymentList: [],
      selectedProjectId: undefined,
      selectedPaymentApplication: undefined,
      currency: this.$Dictionaries.currency,
      method: this.$Dictionaries.trade_payment_nature,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractType: 0,
      purchaseRate: 0,
      amount: 0,
      visibleFrom: false,
      confirmLoadingFrom: false,
      productName: undefined,
      paymentApplication: undefined,
      mdl: {},
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          width: 100,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted () {
    this.loadPaymentApplication()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    contractLabel () {
      if (this.model === undefined || this.model === null || this.model.contract_type === undefined) {
        return ''
      }
      return this.model.contract_type.startsWith('100') ? '购销合同' : '普通合同'
    }
  },
  methods: {
    moment,
    loadPaymentApplication () {
      if (this.model !== undefined && this.model !== null) {
        payment_application_list({ id: this.model.id }).then(res => {
          if (res.code === 1000) {
            const result = res.data.entries || []
            if (result.length > 0) {
              this.paymentApplication = result[0]
              this.loadEditInfo(result[0])
            }
          }
        })
      }
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.sellContractList = []
        this.clientList = []
        this.form.setFieldsValue({ contract_id: undefined })
        this.form.setFieldsValue({ client_id: undefined })
        this.handleClientSearch(undefined)
      }
    },
    handleSellContractSearch (selectedType) {
      const type = selectedType === 101 ? 1 : 2
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999, type: type }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      })
    },
    contractApiByType (type, data) {
      switch (type) {
        case 201:
          return storage_contract_list(data)
        case 206:
          return freight_forwarding_contract_list(data)
        case 203:
          return charter_party_contract_list(data)
        case 204:
          return booking_contract_list(data)
        case 205:
          return inspection_contract_list(data)
        case 207:
          return loading_supervision_contract_list(data)
        case 202:
          return insurance_contract_list(data)
        case 208:
          return supervision_contract_list(data)
        case 209:
          return guarantee_contract_list(data)
        default:
          return contract_list(data)
      }
    },
    handleContractSearch (type, value) {
      this.contractApiByType(type, { project_id: this.selectedProjectId, page: 1, page_size: 999, number: value }).then((res) => {
        const result = res.data.entries || []
        this.contractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      })
    },
    contractTypeChange (values) {
      console.log(values)
      if (values !== undefined && values.length === 2) {
        this.contractType = values[0]
        this.contractList = []
        this.sellContractList = []
        if (values[0] === 100) {
            this.handleSellContractSearch(values[1])
        } else {
          this.handleContractSearch(Number(values[1]), undefined)
        }
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.selectedProjectId }).then((res) => {
        this.clientList = res.data.entries || []
      })
    },
    handlePaymentApplicationChange (value) {
      if (value !== undefined) {
        const selectedPaymentList = this.paymentList.filter(item => item.id === value)
        if (selectedPaymentList.length > 0) {
          this.selectedPaymentApplication = this.paymentList.filter(item => item.id === value)[0]
        }
      console.log('----', this.selectedPaymentApplication)
      }
    },
    handlePaymentSearch (value) {
      this.paymentFetching = true
      payment_application_list({ business_no: value, is_finished: false }).then(res => {
        if (res.code === 1000) {
          this.paymentList = res.data.entries || []
          if (this.paymentList.length === 1) {
            this.selectedPaymentApplication = this.paymentList[0]
          }
        }
      }).finally(() => {
        this.paymentFetching = false
      })
    },
    handleClientChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    payTimeOK (value) {
      console.log(value.format('YYYY-MM-DD HH:mm:ss'))
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.otherData['application'] = this.selectedPaymentApplication
      this.$emit('ok', this.otherData)
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        data.contract_type = data.contract_type.split(',')
        const formData = pick(data, fields)
        form.setFieldsValue(formData)
      })
    },
    purchaseRateChange (value) {
      this.purchaseRate = value
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    },
    amountChange (value) {
      this.amount = value
      const result = (this.purchaseRate * this.amount).toFixed(4)
      console.log(result)
      this.form.setFieldsValue({
        amount_cny: result
      })
    }
  }
}
</script>
